import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import {
    computeDynamicPreview,
    REPORT_PERIOD_OPTIONS,
} from '@src/utils/scheduling';

const SchedulePeriodInput = ({
    reportPeriod = 'previous_month',
    onReportPeriodChange,
    periodOptions = REPORT_PERIOD_OPTIONS,
    previewText,
    frequency,
    frequencyDay,
    day,
    timeOfDay,
    startsOn,
    disabled = false,
    label = 'Report period',
}) => {
    if (!periodOptions || periodOptions.length === 0) {
        return null;
    }

    const currentDay = frequencyDay ?? day;
    const computedPreviewText = previewText === undefined
        ? (frequency && currentDay && timeOfDay
            ? computeDynamicPreview({
                frequency,
                day: currentDay,
                timeOfDay,
                reportPeriod,
                startsOn,
            })
            : null)
        : previewText;

    return (
        <Box>
            <TextField
                select
                fullWidth
                label={label}
                value={reportPeriod}
                disabled={disabled}
                onChange={(e) => {
                    if (onReportPeriodChange) {
                        onReportPeriodChange(e.target.value);
                    }
                }}
            >
                {periodOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
            </TextField>
            {computedPreviewText ? (
                <Typography
                    variant="caption"
                    color="primary"
                    sx={{ display: 'block', mt: 1, fontWeight: 500 }}
                >
                    {computedPreviewText}
                </Typography>
            ) : null}
        </Box>
    );
};

SchedulePeriodInput.propTypes = {
    reportPeriod: PropTypes.string,
    onReportPeriodChange: PropTypes.func,
    periodOptions: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ),
    previewText: PropTypes.string,
    frequency: PropTypes.string,
    frequencyDay: PropTypes.string,
    day: PropTypes.string,
    timeOfDay: PropTypes.string,
    startsOn: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
};

SchedulePeriodInput.defaultProps = {
    reportPeriod: 'previous_month',
    onReportPeriodChange: undefined,
    periodOptions: REPORT_PERIOD_OPTIONS,
    previewText: undefined,
    frequency: undefined,
    frequencyDay: undefined,
    day: undefined,
    timeOfDay: undefined,
    startsOn: undefined,
    disabled: false,
    label: 'Report period',
};

export default SchedulePeriodInput;
